const overlayStyle = {
  backgroundColor: 'rgba(128,128,128,0.6)'
}

const createTicketOverlayStyle = {
  backgroundColor: 'rgba(128,128,128,0.6)',
  zIndex: 4000
}

const confirmOverlayStyle = {
  backgroundColor: 'rgba(128,128,128,0.6)',
  zIndex: 5000
}

const loaderOverlayStyle = {
  backgroundColor: 'rgba(128,128,128,0.6)',
  zIndex: 9999
}

const inputOverlayStyle = {
  backgroundColor: 'rgba(128,128,128,0.6)',
  zIndex:4401
}

export const scrollToBottom = false;
export const loaderModalStyle = {
  overlay: loaderOverlayStyle,
  content: {
    width: '15%',
    height: '30%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    background: 'transparant',
    border: 'none'
  }
};

export const confirmModalStyle = {
  overlay: confirmOverlayStyle,
  content: {
    maxWidth: '90vw',
    maxHeight: '90vh',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    right: 'unset',
    bottom: 'unset',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    zIndex: '9999'
  }
};

export const errorModalStyle = {
  overlay: {
    backgroundColor: 'rgba(128,128,128,0.6)',
    zIndex: 5000
  },
  content: {
    width: '30%',
    height: '32%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    zIndex: 5001
  }
};

export const changeModalStyle = {
  overlay: overlayStyle,
  content: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'left'
  }
}

export const selectModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    borderRadius: '0',
    border: '0'
  }
};

export const splashModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '25%',
    height: '25%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    borderRadius: '0',
    border: '0'
  }
};

export const configurationModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '70%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    border: '0'
  }
}

export const splitReceiptModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '80%',
    height: '75%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0)',
    border: 'none'
  }
}

export const searchModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '50%',
    height: '85%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const receiptModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '65%',
    height: '75%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const paymentModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '40%',
    height: '35%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const datePickerModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '400px',
    height: '400px',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
    padding: '10px'
  }
}

export const customerExistsModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const customerBaseModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const articleBaseModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const ticketBaseModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const selectPagerModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const configurationListModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    borderRadius: '0',
    border: '0'
  }
}

export const managerLoginModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none'
  }
}

export const orderListModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '95%',
    height: '95%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none'
  }
}

export const orderConfirmationModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '35%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const inputModalStyle = {
  overlay: inputOverlayStyle,
  content: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'left',
    zIndex: 4400
  }
}

export const createCustomerModalStyle = {
  overlay: overlayStyle,
  content: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'left'
  }
}

export const createTicketModalStyle = {
  overlay: createTicketOverlayStyle,
  content: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'left'
  }
}

export const cashRegistrationModalStyle = {
  overlay: overlayStyle,
  content: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'left'
  }
}

export const invoiceModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '40%',
    height: '75%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const reservationModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '40%',
    height: '75%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}

export const addBalanceModalStyle = {
  overlay: overlayStyle,
  content: {
    width: '40%',
    height: '75%',
    outline: '0',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    backgroundColor: '#FFF',
    border: 'none',
  }
}



// WEBPACK FOOTER //
// src/constants/Properties.js